(() => {
  // app/scripts/get-products.js
  !window.customElements.get("get-products") && window.customElements.define("get-products", class extends HTMLElement {
    constructor() {
      super();
      this.initialize();
    }
    initialize() {
      window.addEventListener("get:products", this.handleGetProducts.bind(this));
    }
    async handleGetProducts(event) {
      const { detail: { ids = [], type = "default" } = {} } = event;
      const queryString = this.buildQueryString(ids);
      const baseUrl = this.dataset.url;
      if (!baseUrl) {
        console.error("No URL provided in dataset.url for get-products element");
        return;
      }
      if (type !== "infinite") {
        this.innerHTML = "";
      }
      try {
        await this.fetchProducts(baseUrl, queryString, type);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    }
    buildQueryString(ids) {
      return ids.map((i) => {
        if (i.variantTitle != "Default Title") {
          return `(variants.title:${i.variantTitle} AND id:${i.id})`;
        }
        return `id:${i.id}`;
      }).join(" OR ");
    }
    async fetchProducts(baseUrl, queryString, type) {
      const url = `${baseUrl}${queryString}`;
      try {
        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.text();
        const resultFragment = document.createDocumentFragment();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data.split("<!-- ||| -->")[1];
        while (tempDiv.firstElementChild) {
          resultFragment.appendChild(tempDiv.firstElementChild);
        }
        this.appendChild(resultFragment);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        window.dispatchEvent(new CustomEvent("products:error", {
          detail: {
            error: error.message,
            type,
            queryString
          }
        }));
      }
    }
  });
})();
